export default __webpack_public_path__ + "static/basisDocs-f4b4309ab26039cf0e9d33d28c854c98.mp4";